import React from 'react';
import { Helmet } from "react-helmet";
import { Link } from 'gatsby-plugin-intl';
import { WelcomeSellBox, BreadCrumbBlock, SideCategoryMenu, RepeatingPostItem, RecentlyViewMenu } from '../../../components';
import { getLinkPrefix } from '../../../utils/getLinkPrefix';
export const CategoryLayout = ({ data, pageContext, location, uri, country_code }) => {
  const langKey = pageContext.intl.language;
  country_code = country_code ? country_code : "us";
  const subCategoryExists = data.mb.subcategories?.length > 0;
  const MAX_BLOGPOST_LIST_PER_CATEGORY = 6;

  const getSortList = (subcategory) => {
    const merged_blogposts = [];
    const og_blogposts = [];

    if (subcategory.blogposts) {
      og_blogposts.push(...subcategory.blogposts);
    }

    if (data.mb.subcategory_blogposts?.length > 0) {
      const blogpost_items = data.mb.subcategory_blogposts.find((item) => item.subcategory_id === subcategory.id) ? data.mb.subcategory_blogposts.find((item) => item.subcategory_id === subcategory.id).items.blogposts : null;

      // merge sort blogposts with original blogposts
      if (blogpost_items) {
        blogpost_items.forEach(item => {
          const findIndex = og_blogposts.findIndex(blogpost => blogpost.id === item.id);
          if (findIndex > -1) {
            merged_blogposts.push(og_blogposts[findIndex]);
            og_blogposts.splice(findIndex, 1);
          }
        });
      }
      // check if we have unaccounted elements
      if (og_blogposts.length > 0) {
        merged_blogposts.push(...og_blogposts);
      }
    }
    else {
      merged_blogposts.push(...og_blogposts);
    }

    return merged_blogposts;
  }

  return (
    <div className="categories">
      <Helmet htmlAttributes={{ lang: `${pageContext.language}` }}>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1, minimum-scale=1" />
        <meta content={`https://www.freeconferencecall.com${uri}`} property="og:url" />
        <link rel="canonical" href={`https://www.freeconferencecall.com${uri.replace(`${country_code}/`, '')}`} />
        {
          data.mb.category.metadata?.map(item => (
            <meta key={item.id} name={item.name} content={item.content} />
          ))
        }
        <title>FreeConferenceCall Support Center</title>
      </Helmet>
      <WelcomeSellBox country_code={country_code} />
      <BreadCrumbBlock location={location} label={pageContext.name} subcategories={pageContext.subcategories} categories={pageContext.categories} country_code={country_code} />
      <div className="block-sm">
        <div className="container">
          <div className="row">

            {/* Side Categories menu */}
            <div className="col-sm-3">
              <SideCategoryMenu categories={data?.mb?.menu_categories} country_code={country_code} langKey={langKey} />
              <RecentlyViewMenu country_code={country_code} langKey={langKey} />
            </div>

            {/* Right side main content */}
            <div className="col-sm-9 main-section">
              <h2 className="section-title">{pageContext.name}</h2>

              {/* subcategories lists */}
              {subCategoryExists ?
                <div className="sub-categories-sections">
                  {data?.mb?.subcategories?.map((subcategory, index) => {
                    const localize_subcategory = subcategory.localizations.find(item => item.locale === pageContext.locale) || subcategory;
                    return (
                      <div key={index} className="section-column">
                        <h4>{localize_subcategory.name}</h4>
                        <ul>
                          {
                            subcategory.blogposts ? getSortList(subcategory).slice(0, MAX_BLOGPOST_LIST_PER_CATEGORY).map(post => {
                              const localize_post = post.localizations.find(item => item.locale === pageContext.locale) || post;
                              return (
                                <li key={post.id}>
                                  <Link className="category-link" to={getLinkPrefix('articles', `${post.slug}`)} language={langKey} title={localize_post.title}>
                                    {localize_post.title}
                                  </Link>
                                </li>
                              )
                            }) : null}

                          {
                            (getSortList(subcategory).length > MAX_BLOGPOST_LIST_PER_CATEGORY) &&
                            <Link className="category-link margin-top-sm" to={getLinkPrefix('subcategories', `${pageContext.link}/${subcategory.link}`)} language={langKey} title={subcategory.name}>
                              See all articles...
                            </Link>
                          }
                        </ul>
                      </div>
                    )
                  })}
                </div>
                : null
              }

              {/* If no subcategories, then try to show list of posts */}
              {(!subCategoryExists && data?.mb?.posts.length > 0) ? (
                <div className="category-list">
                  {data.mb.posts.map(post => (
                    <RepeatingPostItem key={post.id} post={post} langKey={langKey} />
                  ))}
                </div>
              )
                : ''}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
};
